import React from "react";
import PropTypes from "prop-types";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

// Reusable Daily / Weekly / Monthly granularity toggle shared by the energy,
// session and revenue trend charts.

export const GRANULARITIES = ["daily", "weekly", "monthly"];

const LABELS = {
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
};

const TimeGranularitySelector = ({ value, onChange, size = "small", sx = {} }) => {
  const handleChange = (event, next) => {
    // ToggleButtonGroup yields null when the active button is re-clicked; ignore
    // that so there is always a selected granularity.
    if (next !== null) onChange(next);
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size={size}
      aria-label="consumption granularity"
      sx={{
        "& .MuiToggleButton-root": {
          px: { xs: 1, sm: 1.5 },
          py: 0.25,
          textTransform: "none",
          fontSize: { xs: "0.7rem", sm: "0.75rem" },
          fontWeight: 600,
          lineHeight: 1.6,
        },
        ...sx,
      }}
    >
      {GRANULARITIES.map((g) => (
        <ToggleButton key={g} value={g} aria-label={LABELS[g]}>
          {LABELS[g]}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

TimeGranularitySelector.propTypes = {
  value: PropTypes.oneOf(GRANULARITIES).isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.string,
  sx: PropTypes.object,
};

export default TimeGranularitySelector;
